/* global google */
/* eslint-disable no-undef */
import edap from '../edap';
import {GoogleMap, injectMap} from '@homeaway/react-google-maps';
import MapMarker, {mapPin} from './map-marker';
import React, {Component} from 'react';
import withAuth from '../../components/auth/with-auth';

// world search
export const DEFAULT_BOUNDS = {
    neLat: 82.12492067499629,
    neLong: 58.172218749999956,
    swLat: -78.48103194080132,
    swLong: -124.99184375000004
};

export const getDefaultBounds = () => {
    const {neLat, neLong, swLat, swLong} = DEFAULT_BOUNDS;
    return new google.maps.LatLngBounds(
        new google.maps.LatLng(swLat, swLong),
        new google.maps.LatLng(neLat, neLong)
    );
};

/** @returns {LatLngBounds} */
export const getBounds = (listings = []) => {
    if (!Array.isArray(listings)) {
        return getDefaultBounds();
    }
    let bounds = null;
    listings.forEach((listing) => {
        const {geoCode} = listing || {};
        const {latitude, longitude} = geoCode || {};
        if (latitude && longitude) {
            bounds = bounds || new google.maps.LatLngBounds();
            bounds.extend({lat: latitude, lng: longitude});
        }
    });

    return bounds || getDefaultBounds();
};

export const getListings = (listings) => {
    if (!Array.isArray(listings)) {
        return [];
    }
    return listings.filter((listing) => listing);
};


/**
 * transform bounds for component
 * @returns {neLat, neLong, swLat, swLong}
 * @todo bounds prop isn't working; having to manually call fitBounds
 * Need to figure out why
 * */
export const getTransformedBounds = (bounds) => {
    if (!(bounds instanceof google.maps.LatLngBounds)) {
        // world search
        return DEFAULT_BOUNDS;
    }
    const ne = bounds.getNorthEast();
    const sw = bounds.getSouthWest();
    return {
        neLat: ne.lat(),
        neLong: ne.lng(),
        swLat: sw.lat(),
        swLong: sw.lng()
    };
};

export class ListingsMap extends Component {
    constructor(props) {
        super(props);
        this.googleMapRef = null;
        this.googleMap = null;
        this.state = {
            bounds: null,
            icon: null,
            listings: getListings(props.listings),
            overlay: null,
            transformedBounds: null,
            zoom: null
        };
    }

    componentWillMount() {
        const {listings} = this.state;
        const bounds = getBounds(listings);
        const transformedBounds = getTransformedBounds(bounds);
        const icon = mapPin();
        // must set zoom to null so the component doesn't override our bounds calculations
        const zoom = listings && listings.length === 1 ? 13 : null;
        this.setState({bounds, icon, transformedBounds, zoom});
    }

    componentWillReceiveProps(nextProps) {
        const listings = getListings(nextProps.listings);
        this.setState({listings});
    }

    handleMarkerClick = (e, listing) => {
        const {boardId} = this.props;
        const {unitUuid} = listing || {};
        this.setState({overlay: unitUuid || null});
        edap.mapMarkerClicked(boardId, unitUuid);
    }

    onClick = () => {
        const {boardId} = this.props;
        this.resetOverlay();
        edap.mapInteraction(boardId, 'map.click');
    }

    onDragEnd = () => {
        const {boardId} = this.props;
        edap.mapInteraction(boardId, 'dragged');
    }

    onZoomChanged = () => {
        const {boardId} = this.props;
        this.resetOverlay();
        edap.mapInteraction(boardId, 'zoom');
    }

    resetOverlay = () => {
        this.setState({overlay: null});
    }

    render() {
        const {icon, listings, overlay, transformedBounds, zoom} = this.state;
        const {boardId} = this.props;

        return (
            <GoogleMap
                bounds={transformedBounds}
                containerElement={<div className="listing-map" style={{height: '100%'}} />}
                onClick={this.onClick}
                onDragEnd={this.onDragEnd}
                onMapLoad={this.onMapLoad}
                onZoomChanged={this.onZoomChanged}
                options={{
                    backgroundColor: '#f1f3f5',
                    streetViewControl: false,
                    rotateControl: false,
                    fullscreenControl: false,
                    styles: [
                        {
                            featureType: 'poi',
                            elementType: 'all',
                            stylers: [
                                {
                                    visibility: 'on'
                                }
                            ]
                        }
                    ]
                }}
                ref={(map) => (this.googleMapRef = map)}
                zoom={zoom}
            >
                {listings && listings.map((listing) => {
                    /* istanbul ignore next */
                    if (!listing) {
                        return null;
                    }
                    const {unitUuid} = listing;
                    return (
                        <MapMarker
                            boardId={boardId}
                            icon={icon}
                            key={unitUuid}
                            listing={listing}
                            onClick={this.handleMarkerClick}
                            showOverlay={unitUuid === overlay}
                        />
                    );
                })}
            </GoogleMap>
        );
    }
}

export default withAuth(injectMap(ListingsMap));



// WEBPACK FOOTER //
// ./src/universal/tripboard/listings-map/listings-map.js